import { useQueryClient } from '@tanstack/react-query'

import { LogSource } from '@/types/logs'

const CONDITION_TO_INVALIDATE = ['finishedLogs', true, LogSource.Manual, 'controllerLogs']

export const useInvalidateUnfinishedRecords = () => {
    const queryClient = useQueryClient()

    const invalidateUpdatedRecords = () => {
        queryClient.invalidateQueries({
            predicate: ({ queryKey }) => CONDITION_TO_INVALIDATE.some((condition) => queryKey.includes(condition)),
        })
    }

    return { invalidateUpdatedRecords }
}
